"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getAppUrl", {
    enumerable: true,
    get: function() {
        return getAppUrl;
    }
});
const getAppUrl = ()=>{
    var _process_env_NC_DASHBOARD_URL;
    const siteUrl = process.env.NC_PUBLIC_URL || `http://localhost:${process.env.PORT || 8080}`;
    return `${siteUrl}${(_process_env_NC_DASHBOARD_URL = process.env.NC_DASHBOARD_URL) != null ? _process_env_NC_DASHBOARD_URL : '/dashboard'}`;
};
